import {createApp} from 'vue'
import { vMaska } from "maska/vue"
import App from './App.vue'
import router from "@/routers";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import api from "@/api";
import store from './store'
import './assets/global.css'



const app = createApp(App)

app.use(store)

app.use(router)
app.use(VueSweetalert2)
app.directive("maska", vMaska)
app.config.globalProperties.$api = api;
app.config.globalProperties.$gobBlue = '#273474';
app.config.globalProperties.$gobGray = '#97989a';
app.config.globalProperties.$gobGolden = '#DB473C';
app.config.compilerOptions.isCustomElement = tag => {
    return ['a-scene', 'a-marker', 'a-entity'].includes(tag);
};
router.isReady().then(() => {
    app.mount('#app')
})
